import ExternalLink from '../single/externalLink';

const Perceivable = () => {
	return (
		<>
		<h2 id="perceivable">Principio 1. <ExternalLink href="https://www.w3.org/TR/WCAG21/#perceivable" contents="Perceptible" /></h2>
		<blockquote>
		<p>La información y los componentes de la interfaz de usuario deben presentarse en modos que los usuarios puedan percibirlos.</p>
		</blockquote>
		</>
	)
}

export default Perceivable;
